import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage";
/* import CryptoJS from "crypto-js";
 */
const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: () => import("@/views/portfolio/Portfoliomore"),
      },
      {
        path: "logo",
        component: () => import("@/views/portfolio/Logo"),
      },
      {
        path: "appui",
        component: () => import("@/views/portfolio/appui"),
      },
      {
        path: "website",
        component: () => import("@/views/portfolio/website"),
      },
      {
        path: "dashboard",
        component: () => import("@/views/portfolio/dashboard"),
      },
      {
        path: "wireframing",
        component: () => import("@/views/portfolio/wireframing"),
      },
      {
        path: "banners",
        component: () => import("@/views/portfolio/wireframing"),
      },
      {
        path: "screenshot",
        component: () => import("@/views/portfolio/screenshot"),
      },
    ],
  },
];

/* const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: "hash",
  routes: routes,
}); */

/* router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
 
    let convertdata ="dabhibk";
    const bdkeylocal = localStorage.getItem("bdkey");

    if (bdkeylocal !== null) {
      let getdecrypt = CryptoJS.AES.decrypt(bdkeylocal, "khushi").toString(
        CryptoJS.enc.Utf8
      );

      if (convertdata !== getdecrypt) {
        localStorage.removeItem("bdkey");
        next({ name: "Portfolio" });

      } else if (getdecrypt === convertdata) {
        next();
      } else {
        next({ name: "Home" });
      }
     
    }else{
      next({ name: "Home" });
    }
  } else {
    next();
  }
}); */

const router = createRouter({
 history: createWebHistory(process.env.BASE_URL),
 routes,
 scrollBehavior(to, from, savedPosition) {
    // Back/forward button scroll position
    if (savedPosition) {
      return savedPosition;
    }
    // If navigating to a hash (#id)
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth", // smooth scrolling
      };
    }
    // Default scroll to top
    return { top: 0 };
  },
})
export default router;
